<template>
  <div class="li-item">
    <span/>
    <div class="text" :style="`margin-right:${marginRight}px`">
      {{text}}
    </div>
    <slot name="detail">

    </slot>
  </div>

</template>

<script>
export default {
  name: "li-item",
  props:{
    text:{
      type:String,
      default:''
    },
    marginRight:{
      type:String,
      default: "0"
    }

  }
}
</script>

<style scoped lang="less">
.li-item{
  display: flex;
  align-items: center;
  span{
    display: inline-block;
    width: 6px;
    height: 6px;
    background: var(--brand-blue, #1A1D24);
    border-radius: 50%;
    margin: 0 10px 0 0;
  }
  .text{
    color: var(--text-main, #111827);
    font-size: 14px;
    font-weight: 400;
  }

}

</style>
